import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import VendorPaymentComponent from "./VendorPaymentComponent";
import Uri from "../../Network/Uri";
import {
  GET_VENDOR_INVOICES,
  GET_VENDORS,
  GET_PAYMENTS,
  ADD_PAYMENT,
  UPDATE_PAYMENT,
  DELETE_PAYMENT,
  UPDATE_PAYMENT_BILL_IMAGE,
  ADD_VENDOR,
  ADD_VENDOR_INVOICE,
  HOST_PREFIX,
} from "../../Network/ApiPaths";
import postClientDataResponse from "../../Network/PostClientDataResponse";
import getResponseClient from "../../Network/GetClientDataResponse";

let storeFresh;
let clientHost;
class VendorPaymentContainer extends React.Component {
  constructor(props) {
    super(props);
    const client = window.localStorage.getItem("clientAccess");
    storeFresh = JSON.parse(client);
    if (storeFresh !== null) {
      clientHost = storeFresh.host;
    }
    this.state = {
      payments: [],
      vendors: [],
      invoices: [],
      // Form Fields
      selectedVendor: "",
      selectedInvoice: "",
      pendingAmount: "",
      paymentAmount: "",
      balance_after: "",
      paymentDate: "",
      paymentMode: "",
      transactionRef: "",
      notes: "",
      paymentFile: null,
      importFile: null,
      // Filters
      filterVendorId: "",
      filterFromDate: "",
      filterToDate: "",
      filterStatus: "",
      importing: false,
      importProgress: 0,
    };
  }
  componentDidMount() {
    this.getPayments();
    this.getVendors();
  }
  // ===== Handlers for Form Fields =====
  onVendorChange = (e) => {
    this.setState({
      selectedVendor: e.target.value,
      // clear everything tied to the previous vendor's invoice
      selectedInvoice: "",
      pendingAmount: "",
      paymentAmount: "",
      balance_after: "",
    });
  };
  onInvoiceChange = (e) => {
    const selectedInvoice = e.target.value;
    const invoice = this.state.invoices.find(
      (inv) => Number(inv.id) === Number(selectedInvoice)
    );
    // Total paid for this invoice
    const totalPaid = this.state.payments
      .filter((p) => Number(p.invoice_id) === Number(selectedInvoice))
      .reduce((sum, p) => sum + Number(p.payment_amount), 0);
    const pendingAmount = invoice
      ? Number(invoice.invoice_amount) - totalPaid
      : 0;
    this.setState({
      selectedInvoice,
      pendingAmount,
      paymentAmount: "",
      balance_after: Number(pendingAmount).toFixed(2)
    });
  };
  onPaymentAmountChange = (e) => {
    const paymentAmount = Number(e.target.value);
    if (paymentAmount < 0) {
      alert("Payment amount cannot be negative.");
      return;
    }
    this.setState({
      paymentAmount,
      balance_after: (Number(this.state.pendingAmount) - paymentAmount).toFixed(2)
    });
  };
  onPaymentDateChange = (e) => this.setState({ paymentDate: e.target.value });
  onPaymentModeChange = (e) => this.setState({ paymentMode: e.target.value });
  onTransactionRefChange = (e) => this.setState({ transactionRef: e.target.value });
  onNotesChange = (e) => this.setState({ notes: e.target.value });
  onPaymentFileChange = (e) => this.setState({ paymentFile: e.target.files[0] });
  onImportFileChange = (e) => {
    const file = e.target.files[0];
    console.log(file);
    this.setState({
      importFile: file,
    });
  };
  // ===== Handlers for Filters =====
  onFilterVendorChange = (e) => this.setState({ filterVendorId: e.target.value });
  onFilterFromDateChange = (e) => this.setState({ filterFromDate: e.target.value });
  onFilterToDateChange = (e) => this.setState({ filterToDate: e.target.value });
  onFilterStatusChange = (e) => { this.setState({ filterStatus: e.target.value }); };
  onResetFilters = () => {
    this.setState({
      filterVendorId: "",
      filterFromDate: "",
      filterToDate: "",
    });
  };
  // ===== API Calls =====
  addPayment = (e) => {
    e.preventDefault();
    // Prevent overpayment
    const pending = Number(this.state.pendingAmount);
    const paying = Number(this.state.paymentAmount);
    if (paying <= 0) {
      alert("Payment amount must be greater than 0.");
      return;
    }
    if (paying > pending) {
      alert("Amount is OVERPAID, Please check the amount again.");
      this.getPayments();
      return; // stop here — nothing gets submitted
    }
    const formData = new FormData();
    formData.append("vendor_id", this.state.selectedVendor);
    formData.append("invoice_id", this.state.selectedInvoice);
    formData.append("pending_amount", this.state.pendingAmount);
    formData.append("payment_amount", this.state.paymentAmount);
    formData.append("payment_date", this.state.paymentDate);
    formData.append("balance_after", this.state.balance_after);
    formData.append("payment_mode", this.state.paymentMode);
    formData.append("transaction_ref", this.state.transactionRef);
    formData.append("notes", this.state.notes);
    formData.append("store_id", storeFresh.storeId);
    //if (this.state.paymentFile) {
    //  formData.append("payment_file", this.state.paymentFile);
    //}
    postClientDataResponse(
      clientHost + ADD_PAYMENT,
      storeFresh.key,
      formData,
      async (onSuccessResponse) => {
        if (this.state.paymentFile) {
          await this.UploadFilebyId(
            onSuccessResponse.data.result,
            this.state.paymentFile,
            "Add"
          );
        }
        this.getPayments();   // getInvoices() will be called automatically
        this.getVendors();
        this.setState({
          selectedVendor: "",
          selectedInvoice: "",
          pendingAmount: "",
          paymentAmount: "",
          balance_after: "",
          paymentDate: "",
          paymentMode: "",
          transactionRef: "",
          notes: "",
          paymentFile: null,
        });
      })
  };
  // NOTE: this method isn't currently called from anywhere in
  // VendorPaymentComponent (no button wires it up), and it referenced
  // this.state.invoiceAmount / status / invoiceFile, none of which exist in
  // this component's state. Fixed the endpoint (was posting to ADD_PAYMENT
  // instead of ADD_VENDOR_INVOICE) in case you wire this up later — you'll
  // still need to add real state fields + form inputs for invoice amount,
  // status, and the invoice file before this can work end to end.
  addInvoice = (e) => {
    e.preventDefault();
    const requestBody = {
      vendor_id: this.state.selectedVendor,
      invoice_amount: this.state.invoiceAmount,
      status: this.state.status,
      uploaded_date: new Date().toISOString().split("T")[0],
      store_id: storeFresh.storeId,
    };
    postClientDataResponse(
      clientHost + ADD_VENDOR_INVOICE,
      storeFresh.key,
      requestBody,
      async (onSuccessResponse) => {
        if (this.state.invoiceFile) {
          await this.UploadFilebyId(onSuccessResponse.data.result, this.state.invoiceFile, "Add");
        }
        this.getInvoices();
      },
      (onError) => {
        console.log(onError.message);
      })
  };
  getPayments = () => {
    var apiPath = new Uri(clientHost + GET_PAYMENTS)
      .addQueryParam("store_id", storeFresh.storeId);

    getResponseClient(
      apiPath,
      storeFresh.key,
      (res) => {
        console.log("Payments:", res.result);
        this.setState(
          {
            payments: res.result
          },
          () => {
            // This runs AFTER payments are loaded
            this.getInvoices();
          }
        );
      },
      (err) => console.log(err)
    );
  };
  getVendors = () => {
    var apiPath = new Uri(clientHost + GET_VENDORS).addQueryParam(
      "store_id",
      storeFresh.storeId
    );
    getResponseClient(
      apiPath,
      storeFresh.key,
      (res) => {
        const vendors = (res.result || []).sort((a, b) => {
          const nameA = (a.vendor_name || "").trim();
          const nameB = (b.vendor_name || "").trim();
          const getType = (name) => {
            if (/^[a-zA-Z]/.test(name)) return 1; // A-Z
            if (/^[0-9]/.test(name)) return 2;     // 0-9
            return 3;                              // Special characters
          };
          const typeA = getType(nameA);
          const typeB = getType(nameB);
          // First: A-Z, then 0-9, then special characters
          if (typeA !== typeB) {
            return typeA - typeB;
          }
          // Sort within each category
          return nameA.localeCompare(nameB, undefined, {
            numeric: true,
            sensitivity: "base"
          });
        });
        this.setState({
          vendors: vendors
        });
      },
      (err) => console.log(err)
    );
  };
  getInvoices = () => {
    var apiPath = new Uri(clientHost + GET_VENDOR_INVOICES)
      .addQueryParam("store_id", storeFresh.storeId);
    getResponseClient(
      apiPath,
      storeFresh.key,
      (res) => {
        const updatedInvoices = res.result.map((inv) => {
          const totalPaid = this.state.payments
            .filter(
              (p) => Number(p.invoice_id) === Number(inv.id)
            )
            .reduce(
              (sum, p) => sum + Number(p.payment_amount || 0),
              0
            );
          let status;
          if (totalPaid === 0) {
            status = "NOTPAID";
          }
          else if (totalPaid < Number(inv.invoice_amount)) {
            status = "PARTIAL";
          }
          else if (totalPaid === Number(inv.invoice_amount)) {
            status = "PAID";
          }
          else {
            status = "OVERPAID";
          }
          return {
            ...inv,
            status: status,
            balance_amount: Number(inv.invoice_amount) - totalPaid
          };
        });
        this.setState({
          invoices: updatedInvoices
        });

      },
      (err) => console.log(err)
    );
  };
  refreshInvoices = () => {
    this.getInvoices();
  };
  deletePayment = (id) => {
    const apiPath = new Uri(clientHost + DELETE_PAYMENT)
      .addQueryParam("id", id);
    getResponseClient(
      apiPath,
      storeFresh.key,
      () => {
        this.getPayments();
      },
      (err) => console.log(err)
    );
  };
  updatePayment = (payment) => {
    // Prevent overpayment
    const pending = Number(payment.pending_amount);
    const paying = Number(payment.payment_amount);

    if (paying > pending) {
      alert("Amount is OVERPAID. Please check the amount again.");
      return; // stop here — nothing gets submitted
    }
    const formData = new FormData();
    formData.append("id", payment.id);
    formData.append("vendor_id", payment.vendor_id);
    formData.append("invoice_id", payment.invoice_id);
    formData.append("pending_amount", payment.pending_amount);
    formData.append("payment_amount", payment.payment_amount);
    formData.append("balance_after", payment.balance_after);
    formData.append("payment_date", payment.payment_date);
    formData.append("payment_mode", payment.payment_mode);
    formData.append("transaction_ref", payment.transaction_ref);
    formData.append("notes", payment.notes);
    if (payment.payment_file instanceof File) {
      formData.append("payment_file", payment.payment_file);
    }
    postClientDataResponse(
      clientHost + UPDATE_PAYMENT,
      storeFresh.key,
      formData,
      async (onSuccessResponse) => {
        if (payment.payment_file instanceof File) {
          await this.UploadFilebyId(
            onSuccessResponse.data.result,
            payment.payment_file,
            "Update"
          );
        }
        this.getPayments();
        this.getVendors();
      })
  };
  // ===== Export to Excel =====
  // Build the same attachment URL the table renders — the payment object
  // itself never had a `paymentFileUrl` field, so that lookup was always empty.
  getAttachmentUrl = (p) =>
    p.payment_file ? `${HOST_PREFIX}images/payments/${p.id}/${p.payment_file}` : "";
  onExport = (filteredPayments) => {
    const data = filteredPayments.map((p, index) => ({
      "S.No": index + 1,
      "Payment ID": p.id,
      "Vendor Name": this.state.vendors.find((v) => Number(v.id) === Number(p.vendor_id))?.vendor_name || "",
      "Invoice Amount": this.state.invoices.find((inv) => Number(inv.id) === Number(p.invoice_id))?.invoice_amount || "",
      "Pending Amount": p.pending_amount,
      "Payment Amount": p.payment_amount,
      "Status": this.state.invoices.find((inv) => inv.id === p.invoice_id)?.status || "",              // PAID, NOTPAID, PARTIAL, OVERPAID
      "Balance After": p.balance_after,
      "Payment Date": p.payment_date,
      "Payment Mode": p.payment_mode,
      "Transaction Ref": p.transaction_ref,
      "Notes": p.notes,
      "Attachment URL": this.getAttachmentUrl(p),
    }));
    const worksheet = XLSX.utils.json_to_sheet(data);
    // "Attachment URL" is the 12th column (A=S.No ... L=Attachment URL).
    // The old code hard-coded column "I", which is actually "Payment Mode" —
    // that overwrote the wrong cell and never linked the real column.
    const ATTACHMENT_COLUMN = "M";
    filteredPayments.forEach((p, idx) => {
      const url = this.getAttachmentUrl(p);
      if (url) {
        const row = idx + 2; // header is row 1
        const cell = `${ATTACHMENT_COLUMN}${row}`;
        if (!worksheet[cell]) worksheet[cell] = { t: "s", v: url };
        worksheet[cell].l = { Target: url };
      }
    });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Payments");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "Payments.xlsx");
  };

  importExcel = () => {
    if (!this.state.importFile) {
      alert("Please select an Excel file.");
      return;
    }
    this.setState({
      importing: true,
      importProgress: 0
    });
    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, {
          type: "array",
          cellDates: false,
        });
        const allValidRows = [];
        const skippedTables = [];
        const skippedSheets = [];
        const validTables = [];
        // ============================================================
        // CHECK EVERY SHEET
        // ============================================================
        workbook.SheetNames.forEach((sheetName) => {
          const worksheet = workbook.Sheets[sheetName];
          console.log(`\n================================================`);
          console.log(`CHECKING SHEET: ${sheetName}`);
          console.log(`================================================`);
          if (!worksheet) {
            skippedSheets.push(
              `${sheetName} - Worksheet could not be read`
            );
            return;
          }
          // ========================================================
          // DETECT ALL TABLES INSIDE THIS SHEET
          // ========================================================
          const tables =
            this.detectTablesInSheet(
              worksheet,
              sheetName
            );
          console.log(`SHEET "${sheetName}" HAS ${tables.length} TABLE(S)`);
          // ========================================================
          // NO TABLES
          // ========================================================
          if (tables.length === 0) {
            skippedSheets.push(
              `${sheetName} - No valid table header found`
            );
            return;
          }
          // ========================================================
          // PROCESS EACH TABLE
          // ========================================================
          tables.forEach((table, tableIndex) => {
            const tableNumber = tableIndex + 1;
            console.log(`\n------------------------------------------------`);
            console.log(`CHECKING TABLE ${tableNumber} IN SHEET "${sheetName}"`);
            console.log(`HEADER ROW: ${table.headerRow + 1}`);
            console.log(`HEADERS:`, table.headers);
            // ======================================================
            // CHECK REQUIRED COLUMNS
            // ======================================================
            const hasClient = table.clientColumn !== -1;
            const hasDate = table.dateColumn !== -1;
            const hasAmount = table.amountColumn !== -1;
            // ======================================================
            // INVALID TABLE
            // ======================================================
            if (!hasClient || !hasAmount) {
              const missing = [];
              if (!hasClient) missing.push("Client");
              if (!hasDate) missing.push("Date");
              if (!hasAmount) missing.push("Amount");
              console.warn(`SKIPPING TABLE ${tableNumber} IN SHEET "${sheetName}"`);
              console.warn(`Missing columns:`, missing);
              skippedTables.push(
                `${sheetName} - Table ${tableNumber} - Missing: ${missing.join(
                  ", "
                )}`
              );
              return;
            }
            // ======================================================
            // VALID TABLE
            // ======================================================
            console.log(`VALID TABLE ${tableNumber} IN SHEET "${sheetName}"`);
            validTables.push(`${sheetName} - Table ${tableNumber}`);

            // ======================================================
            // CONVERT TABLE ROWS INTO OBJECTS
            // ======================================================
            const tableRows =
              table.dataRows.map((item) => {
                const row =
                  this.convertExcelRowToObject(
                    table.headers,
                    item.values
                  );
                return {
                  ...row,
                  // Important:
                  // Keep actual Excel row number
                  __excelRowNumber:
                    item.excelRowNumber,
                  // Keep sheet/table information
                  __sheetName:
                    sheetName,
                  __tableNumber:
                    tableNumber,
                };
              });
            console.log(`ROWS FOUND IN TABLE ${tableNumber}:`, tableRows);

            const nonEmptyRows = tableRows.filter((row) => {
              return !this.isExcelRowEmpty(Object.values(row));
            });
            if (nonEmptyRows.length === 0) {
              console.log(`TABLE ${tableNumber} HAS NO DATA`);
              return;
            }
            // ======================================================
            // Resolve blank Client names using previous row
            // ======================================================
            const rowsWithClient = this.resolveClientFromPreviousRows(nonEmptyRows);
            // ======================================================
            // Resolve dates like 01to30
            // ======================================================
            const rowsWithDate = this.resolveInvoiceDatesFromPreviousRows(rowsWithClient);
            // ======================================================
            // Add rows for import
            // ======================================================
            allValidRows.push(...rowsWithDate);
            console.log(`ROWS ADDED FROM ${sheetName} TABLE ${tableNumber}:`, rowsWithDate.length);
          });
        });
        // ============================================================
        // NO VALID TABLES
        // ============================================================
        console.log("TOTAL IMPORT ROWS:", allValidRows.length);
        console.log(allValidRows);
        if (
          allValidRows.length === 0
        ) {
          alert(
            `Import failed.\n\n` +
            `No valid tables were found in any worksheet.\n\n` +
            `Required columns for every table:\n` +
            `• Client / Client Name / Vendor / Vendor Name\n` +
            `• Date / Invoice Date\n` +
            `• Amount / Invoice Amount\n\n` +
            `Checked worksheets:\n` +
            `${workbook.SheetNames.join("\n")}`
          );
          return;
        }
        // ============================================================
        // LOG COMPLETE RESULT
        // ============================================================
        console.log(`\n================================================`);
        console.log("ALL WORKSHEETS:", workbook.SheetNames);
        console.log("VALID TABLES:", validTables);
        console.log("SKIPPED TABLES:", skippedTables);
        console.log("SKIPPED SHEETS:", skippedSheets);
        console.log("TOTAL VALID ROWS:", allValidRows.length);
        console.log("ROWS TO IMPORT:", allValidRows);
        console.log(`================================================`);
        // ============================================================
        // START IMPORT
        // ============================================================
        this.setState(
          {
            importing: true,
            importProgress: 0
          },
          async () => {
            try {
              await this.saveImportedPayments(allValidRows);
            } catch (error) {
              console.error(error);
            } finally {
              this.setState({
                importing: false,
                importProgress: 100
              });
            }
          }
        );
        // ============================================================
        // SHOW SKIPPED TABLE INFORMATION
        // ============================================================
        if (
          skippedTables.length > 0
        ) {
          console.warn("Some tables were skipped:", skippedTables);
        }
        if (
          skippedSheets.length > 0
        ) {
          console.warn("Some sheets were skipped:", skippedSheets);
        }
      } catch (error) {
        this.setState({
          importing: false,
          importProgress: 0
        });
        console.error("Excel import error:", error);
        alert(`Excel import failed.\n\n${error.message}`);
      }
    };
    reader.onerror = () => {
      this.setState({
        importing: false,
        importProgress: 0
      });
      alert("Unable to read the Excel file.");
    };
    reader.readAsArrayBuffer(this.state.importFile);
  };
  normalizeVendorName = (name) => {
    return String(name)
      .trim()
      .toLowerCase()
      .split(/\s+/)      // Split by one or more spaces
      .sort()            // Sort words alphabetically
      .join(" ");        // Join back into a string
  };
  normalizeInvoiceDate = (value) => {
    if (value === undefined || value === null) {
      return "";
    }
    const valueStr = String(value).trim();
    const parsed = this.parseAndFormatDate(valueStr);
    return parsed || valueStr;
  };

  fetchVendorsAsync = () => {
    return new Promise((resolve, reject) => {
      const apiPath = new Uri(clientHost + GET_VENDORS).addQueryParam(
        "store_id",
        storeFresh.storeId
      );
      getResponseClient(
        apiPath,
        storeFresh.key,
        (data) => {
          const list = Array.isArray(data?.result)
            ? data.result
            : Array.isArray(data?.data)
              ? data.data
              : Array.isArray(data)
                ? data
                : [];
          this.setState({ vendors: list }, () => resolve(list));
        },
        (err) => reject(err)
      );
    });
  };

  fetchInvoicesAsync = (paymentsOverride = null) => {
    return new Promise((resolve, reject) => {
      const apiPath = new Uri(clientHost + GET_VENDOR_INVOICES).addQueryParam(
        "store_id",
        storeFresh.storeId
      );
      getResponseClient(
        apiPath,
        storeFresh.key,
        (data) => {
          const rawInvoices = Array.isArray(data?.result)
            ? data.result
            : Array.isArray(data?.data)
              ? data.data
              : Array.isArray(data)
                ? data
                : [];
          const updatedInvoices = rawInvoices.map((inv) => {
            const paymentsForCalculation = paymentsOverride || this.state.payments || [];
            const totalPaid = paymentsForCalculation
              .filter((p) => Number(p.invoice_id) === Number(inv.id))
              .reduce((sum, p) => sum + Number(p.payment_amount || 0), 0);
            let status;
            if (totalPaid === 0) status = "NOTPAID";
            else if (totalPaid < Number(inv.invoice_amount)) status = "PARTIAL";
            else if (totalPaid === Number(inv.invoice_amount)) status = "PAID";
            else status = "OVERPAID";
            return {
              ...inv,
              status: status,
              balance_amount: Number(inv.invoice_amount) - totalPaid,
            };
          });
          this.setState({ invoices: updatedInvoices }, () =>
            resolve(updatedInvoices)
          );
        },
        (err) => reject(err)
      );
    });
  };

  createVendor = async (vendorName) => {
    const requestBody = {
      vendor_name: vendorName,
      acct_number: "",
      bank_details: "",
      address: "",
      phone_number: "",
      gst: "",
      item_of_supply: "",
      store_id: storeFresh.storeId,
    };

    return new Promise((resolve, reject) => {
      postClientDataResponse(
        clientHost + ADD_VENDOR,
        storeFresh.key,
        requestBody,

        async (res) => {
          try {
            console.log("CREATE VENDOR RESPONSE:", res);

            const responseData =
              res?.data?.result ||
              res?.result ||
              res?.data?.data ||
              res?.data;

            let createdVendor = null;

            if (responseData && typeof responseData === "object") {
              createdVendor = responseData;
            } else if (responseData) {
              createdVendor = {
                id: responseData,
                vendor_name: vendorName,
              };
            }

            if (createdVendor?.id) {
              resolve({
                id: createdVendor.id,
                vendor_name: vendorName,
              });
              return;
            }

            reject(
              new Error(
                `Vendor "${vendorName}" was created but its ID could not be found.`
              )
            );
          } catch (error) {
            reject(error);
          }
        },

        (err) => {
          reject(
            err ||
            new Error(
              `Failed to create vendor "${vendorName}".`
            )
          );
        }
      );
    });
  };

  createInvoice = async (vendorId, item) => {
    const invoiceDate = item.date;
    const invoiceAmount = Number(item.amount);

    const balanceAmount = invoiceAmount;

    const status = "NOTPAID";

    const requestBody = {
      vendor_id: vendorId,
      invoice_date: invoiceDate,
      invoice_amount: invoiceAmount,
      balance_amount: balanceAmount,
      status: status,
      uploaded_date: new Date()
        .toISOString()
        .split("T")[0],
      store_id: storeFresh.storeId,
    };

    console.log("CREATE INVOICE:", requestBody);

    return new Promise((resolve, reject) => {
      postClientDataResponse(
        clientHost + ADD_VENDOR_INVOICE,
        storeFresh.key,
        requestBody,

        async (res) => {
          try {
            console.log("CREATE INVOICE RESPONSE:", res);

            const responseData =
              res?.data?.result ||
              res?.result ||
              res?.data?.data ||
              res?.data;

            const invoiceId =
              typeof responseData === "object"
                ? responseData?.id
                : responseData;

            if (invoiceId) {
              resolve({
                id: invoiceId,
                vendor_id: vendorId,
                invoice_date: invoiceDate,
                invoice_amount: invoiceAmount,
                balance_amount: balanceAmount,
                status: status,
              });
              return;
            }

            reject(
              new Error(
                `Invoice was created but invoice ID could not be found.`
              )
            );
          } catch (error) {
            reject(error);
          }
        },

        (err) => {
          reject(
            err ||
            new Error(
              `Failed to create invoice for vendor ${vendorId}.`
            )
          );
        }
      );
    });
  };

  // Helper to extract a column value supporting multiple header aliases
  getCellValue = (row, aliases) => {
    if (!row || typeof row !== "object") return undefined;
    for (const alias of aliases) {
      if (row[alias] !== undefined && row[alias] !== null && String(row[alias]).trim() !== "") {
        return row[alias];
      }
    }
    return undefined;
  };

  // Helper to check if a row is completely empty
  isEmptyRow = (row) => {
    if (!row || typeof row !== "object") return true;
    return Object.values(row).every(
      (val) => val === undefined || val === null || String(val).trim() === ""
    );
  };

  // ============================================================
  // EXCEL MULTIPLE TABLE HELPERS
  // ============================================================

  // Normalize Excel header names
  normalizeExcelHeader = (value) => {
    if (value === undefined || value === null) {
      return "";
    }

    return String(value)
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ")
      .replace(/[_-]/g, " ");
  };

  // Check whether a cell is one of the required headers
  isClientHeader = (value) => {
    const header = this.normalizeExcelHeader(value);

    return [
      "client",
      "client name",
      "vendor",
      "vendor name",
    ].includes(header);
  };

  isDateHeader = (value) => {
    const header = this.normalizeExcelHeader(value);

    return [
      "date",
      "invoice date",
      "invoicedate",
      "invoice date",
    ].includes(header);
  };

  isAmountHeader = (value) => {
    const header = this.normalizeExcelHeader(value);

    return [
      "amount",
      "invoice amount",
    ].includes(header);
  };

  // Check whether a row is a valid table header
  isValidTableHeader = (row) => {
    if (!Array.isArray(row)) {
      return false;
    }

    const hasClient = row.some((cell) =>
      this.isClientHeader(cell)
    );

    const hasDate = row.some((cell) =>
      this.isDateHeader(cell)
    );

    const hasAmount = row.some((cell) =>
      this.isAmountHeader(cell)
    );

    return hasClient && hasDate && hasAmount;
  };

  // Convert an Excel header row + data row into an object
  convertExcelRowToObject = (headers, values) => {
    const row = {};
    headers.forEach((header, index) => {
      const cleanHeader = String(header || "").trim();
      if (cleanHeader !== "") {
        row[cleanHeader] =
          values[index] !== undefined &&
            values[index] !== null
            ? values[index]
            : "";
      }
    });
    return row;
  };

  // ============================================================
  // FIND HEADER COLUMN INDEX
  // ============================================================
  findHeaderIndex = (headers, headerChecker) => {
    return headers.findIndex((header) =>
      headerChecker(header)
    );
  };

  // ============================================================
  // NORMALIZE EXCEL HEADER
  // ============================================================
  normalizeExcelHeader = (value) => {
    return String(value ?? "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[_-]/g, "");
  };


  // ============================================================
  // CHECK WHETHER A ROW/CELL RANGE CONTAINS A REAL TABLE HEADER
  // ============================================================
  isPaymentTableHeader = (headers) => {
    if (!headers || headers.length === 0) {
      return false;
    }

    const hasClient = headers.some((header) =>
      this.isClientHeader(header)
    );
    const hasDate = headers.some((header) =>
      this.isDateHeader(header)
    );
    const hasAmount = headers.some((header) =>
      this.isAmountHeader(header)
    );

    return hasClient && hasDate && hasAmount;
  };


  // ============================================================
  // CHECK IF A VALUE IS EMPTY
  // ============================================================
  isExcelCellEmpty = (value) => {
    return (
      value === undefined ||
      value === null ||
      String(value).trim() === ""
    );
  };


  // ============================================================
  // CHECK IF A ROW IS COMPLETELY EMPTY
  // ============================================================
  isExcelRowEmpty = (row) => {
    if (!row || row.length === 0) {
      return true;
    }

    return row.every((cell) =>
      this.isExcelCellEmpty(cell)
    );
  };


  // ============================================================
  // CHECK SUMMARY / TOTAL ROW
  // ============================================================
  isSummaryExcelRow = (row) => {
    if (!Array.isArray(row)) {
      return false;
    }

    const text = row
      .map((cell) =>
        String(cell ?? "")
          .trim()
          .toLowerCase()
      )
      .join(" ");
    const summaryWords = [
      "total",
      "grand total",
      "subtotal",
      "total invoiceamount",
      "total invoice amount",
      "totalinvoice amount",
      "total pending",
      "pending total",
    ];
    return summaryWords.some((word) =>
      text.includes(word)
    );
  };
  isClientHeader = (header) => {
    const value = this.normalizeExcelHeader(header);
    return [
      "client",
      "clientname",
      "vendor",
      "vendorname"
    ].includes(value);
  };
  isDateHeader = (header) => {
    const value = this.normalizeExcelHeader(header);
    return [
      "date",
      "invoicedate",
      "invoice_date"
    ].includes(value);
  };
  isAmountHeader = (header) => {
    const value = this.normalizeExcelHeader(header);
    return [
      "amount",
      "invoiceamount",
      "invoice_amount"
    ].includes(value);
  };
  isPaidAmountHeader = (header) => {
    const value = this.normalizeExcelHeader(header);
    return [
      "paidamount",
      "paid_amount",
      "paymentamount",
      "payment_amount",
      "paid"
    ].includes(value);
  };
  isPendingAmountHeader = (header) => {
    const value = this.normalizeExcelHeader(header);
    return [
      "pendingamount",
      "pending_amount",
      "balance",
      "balanceamount"
    ].includes(value);
  };

  findPaymentHeaderColumns = (row) => {
    if (!row || row.length === 0) {
      return null;
    }
    let client = -1;
    let date = -1;
    let amount = -1;
    let paidAmount = -1;
    let pendingAmount = -1;
    row.forEach((cell, index) => {
      const header = this.normalizeExcelHeader(cell);
      if (this.isClientHeader(header)) {
        client = index;
      }
      if (this.isDateHeader(header)) {
        date = index;
      }
      if (this.isAmountHeader(header)) {
        amount = index;
      }
      if (this.isPaidAmountHeader(header)) {
        paidAmount = index;
      }
      if (this.isPendingAmountHeader(header)) {
        pendingAmount = index;
      }
    });
    if (client === -1 || date === -1 || amount === -1) {
      return null;
    }
    return {
      client,
      date,
      amount,
      paidAmount,
      pendingAmount
    };
  };
  // ============================================================
  // DETECT ALL TABLES INSIDE ONE WORKSHEET
  //
  // Supports:
  // 1. Multiple tables vertically
  // 2. Multiple tables horizontally
  // 3. Tables separated by blank rows
  // 4. Tables separated by blank columns
  // 5. Different starting columns
  // 6. Different table widths
  // ============================================================
  detectTablesInSheet = (worksheet, sheetName) => {
    console.log("==========================================");
    console.log("DEBUG SHEET:", sheetName);
    console.log("WORKSHEET REF:", worksheet["!ref"]);

    const rawRows = XLSX.utils.sheet_to_json(worksheet, {
      header: 1,
      raw: true,
      defval: "",
      blankrows: true,
    });

    console.log("RAW ROW COUNT:", rawRows.length);

    // ------------------------------------------------------------
    // DEBUG ALL ROWS
    // ------------------------------------------------------------
    rawRows.forEach((row, index) => {
      console.log(
        `EXCEL ROW ${index + 1}:`,
        row
      );
    });

    // ------------------------------------------------------------
    // FIND POSSIBLE TABLES
    // ------------------------------------------------------------
    const tables = [];
    for (let rowIndex = 0; rowIndex < rawRows.length; rowIndex++) {
      const row = rawRows[rowIndex];
      if (!row || row.length === 0) {
        continue;
      }

      const headerIndexes =
        this.findPaymentHeaderColumns(row);

      if (headerIndexes) {
        console.log(
          `PAYMENT HEADER DETECTED AT EXCEL ROW ${rowIndex + 1}:`,
          row
        );

        console.log(
          "HEADER INDEXES:",
          headerIndexes
        );
      }

      if (!headerIndexes) {
        continue;
      }

      console.log(
        `TABLE HEADER FOUND - Sheet: ${sheetName}, Excel Row: ${rowIndex + 1
        }`,
        row
      );

      // ----------------------------------------------------------
      // CREATE TABLE
      // ----------------------------------------------------------
      const table = {
        sheetName,
        headerRow: rowIndex,
        headers: row,
        dataRows: [],
        clientColumn: headerIndexes.client,
        dateColumn: headerIndexes.date,
        amountColumn: headerIndexes.amount,
        paidAmountColumn: headerIndexes.paidAmount,
        pendingAmountColumn: headerIndexes.pendingAmount,
      };

      // ----------------------------------------------------------
      // FIND DATA ROWS BELOW HEADER
      // ----------------------------------------------------------
      let previousClient = "";

      for (
        let dataIndex = rowIndex + 1;
        dataIndex < rawRows.length;
        dataIndex++
      ) {
        const dataRow = rawRows[dataIndex];
        if (this.isStopSectionRow(dataRow)) {
          console.log("Summary section found. Stopping current table.");
          break;
        }
        // ----------------------------------------------
        // Completely empty row
        // ----------------------------------------------
        const isEmptyRow =
          !dataRow ||
          this.isExcelRowEmpty(dataRow)

        if (isEmptyRow) {
          // allow one blank row inside a table
          let next = dataIndex + 1;
          while (
            next < rawRows.length &&
            (
              !rawRows[next] ||
              rawRows[next].every(
                c =>
                  c === undefined ||
                  c === null ||
                  String(c).trim() === ""
              )
            )
          ) {
            next++;
          }
          // another header -> next table
          if (
            next < rawRows.length &&
            this.findPaymentHeaderColumns(rawRows[next])
          ) {
            break;
          }
          // otherwise continue scanning
          continue;
        }

        // ----------------------------------------------
        // Another header = new table
        // ----------------------------------------------
        const nextHeader = this.findPaymentHeaderColumns(dataRow);
        if (dataIndex !== rowIndex + 1 && nextHeader) {
          break;
        }

        // ----------------------------------------------
        // Ignore summary rows
        // ----------------------------------------------
        if (this.isSummaryExcelRow(dataRow)) {
          console.log(
            `IGNORING SUMMARY ROW ${dataIndex + 1}:`,
            dataRow
          );
          continue;
        }

        // ----------------------------------------------
        // Get client
        // ----------------------------------------------
        let clientValue = "";

        if (headerIndexes.client !== -1) {
          clientValue =
            dataRow[headerIndexes.client] ?? "";
        }

        clientValue = String(clientValue).trim();

        // ----------------------------------------------
        // Continue previous client
        // ----------------------------------------------
        if (clientValue !== "") {
          previousClient = clientValue;
        } else if (previousClient !== "") {
          clientValue = previousClient;
        }

        // ----------------------------------------------
        // Store row
        // ----------------------------------------------
        const amount =
          dataRow[headerIndexes.amount];

        if (clientValue === "" && (amount === "" || amount === undefined)) {
          continue;
        }
        table.dataRows.push({
          values: dataRow,
          excelRowNumber: dataIndex + 1,
        });
      }

      console.log(
        `ROWS FOUND IN TABLE:`,
        table.dataRows
      );
      tables.push(table);
    }

    console.log(
      `FINAL TABLE COUNT FOR "${sheetName}":`,
      tables.length
    );

    console.log("==========================================");

    return tables;
  };
  isStopSectionRow = (row) => {
    if (!Array.isArray(row)) return false;

    const text = row
      .map(cell => String(cell ?? "").trim().toLowerCase())
      .join(" ");

    const stopWords = [
      "dec pending azghar",
      "total",
      "inventory expenses",
      "otherexpenses",
      "pettycashexpenses",
      "total expenses",
      "payments done",
      "pending payments"
    ];
    return stopWords.some(word => text.includes(word));
  };
  // Helper to validate and format dates into YYYY-MM-DD.
  // Supports:
  // YYYY-MM-DD
  // DD/MM/YYYY
  // DD-MM-YYYY
  // DD/MM/YY
  // DD-MM-YY
  // Excel Date objects
  parseAndFormatDate = (val) => {
    if (
      val === undefined ||
      val === null ||
      String(val).trim() === ""
    ) {
      return null;
    }
    // ============================================================
    // JavaScript Date
    // ============================================================
    if (val instanceof Date) {
      if (isNaN(val.getTime())) {
        return null;
      }
      const year = val.getUTCFullYear();
      const month = String(val.getUTCMonth() + 1).padStart(2, "0");
      const day = String(val.getUTCDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    const str = String(val).trim();
    // ============================================================
    // DATE RANGE
    // Supports:
    // 01-06-2025to30-06-2025
    // 01-06-2025 to 30-06-2025
    // Uses the LAST date only.
    // ============================================================
    const rangeMatch = str.match(
      /^(\d{1,2}-\d{1,2}-\d{4})\s*to\s*(\d{1,2}-\d{1,2}-\d{4})$/i
    );
    if (rangeMatch) {
      // Use the last date after "to"
      return this.parseAndFormatDate(rangeMatch[2]);
    }
    // ============================================================
    // Excel serial number
    // ============================================================
    if (
      typeof val === "number" &&
      Number.isFinite(val) &&
      val > 30000
    ) {
      try {
        const parsed = XLSX.SSF.parse_date_code(val);
        if (parsed && parsed.y && parsed.m && parsed.d) {
          return `${String(parsed.y).padStart(4, "0")}-${String(
            parsed.m
          ).padStart(2, "0")}-${String(parsed.d).padStart(2, "0")}`;
        }
      } catch (error) {
        console.error("Excel date conversion error:", error);
      }
    }
    // ============================================================
    // Remove time
    // ============================================================
    const dateOnly = str.split(" ")[0];
    // ============================================================
    // DD/MM/YYYY
    // ============================================================
    let match = dateOnly.match(
      /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/
    );
    if (match) {
      const day = Number(match[1]);
      const month = Number(match[2]);
      const year = Number(match[3]);
      if (
        day >= 1 &&
        day <= 31 &&
        month >= 1 &&
        month <= 12
      ) {
        return `${year}-${String(month).padStart(2, "0")}-${String(
          day
        ).padStart(2, "0")}`;
      }
    }
    // ============================================================
    // DD-MM-YYYY
    // ============================================================
    match = dateOnly.match(
      /^(\d{1,2})-(\d{1,2})-(\d{4})$/
    );
    if (match) {
      const day = Number(match[1]);
      const month = Number(match[2]);
      const year = Number(match[3]);
      if (
        day >= 1 &&
        day <= 31 &&
        month >= 1 &&
        month <= 12
      ) {
        return `${year}-${String(month).padStart(2, "0")}-${String(
          day
        ).padStart(2, "0")}`;
      }
    }
    // ============================================================
    // DD/MM/YY
    // ============================================================
    match = dateOnly.match(
      /^(\d{1,2})\/(\d{1,2})\/(\d{2})$/
    );
    if (match) {
      const day = Number(match[1]);
      const month = Number(match[2]);
      const year = 2000 + Number(match[3]);
      if (
        day >= 1 &&
        day <= 31 &&
        month >= 1 &&
        month <= 12
      ) {
        return `${year}-${String(month).padStart(2, "0")}-${String(
          day
        ).padStart(2, "0")}`;
      }
    }
    // ============================================================
    // DD-MM-YY
    // ============================================================
    match = dateOnly.match(
      /^(\d{1,2})-(\d{1,2})-(\d{2})$/
    );
    if (match) {
      const day = Number(match[1]);
      const month = Number(match[2]);
      const year = 2000 + Number(match[3]);
      if (
        day >= 1 &&
        day <= 31 &&
        month >= 1 &&
        month <= 12
      ) {
        return `${year}-${String(month).padStart(2, "0")}-${String(
          day
        ).padStart(2, "0")}`;
      }
    }
    // ============================================================
    // YYYY-MM-DD
    // ============================================================
    match = dateOnly.match(
      /^(\d{4})-(\d{1,2})-(\d{1,2})$/
    );
    if (match) {
      const year = Number(match[1]);
      const month = Number(match[2]);
      const day = Number(match[3]);
      if (
        month >= 1 &&
        month <= 12 &&
        day >= 1 &&
        day <= 31
      ) {
        return `${year}-${String(month).padStart(2, "0")}-${String(
          day
        ).padStart(2, "0")}`;
      }
    }
    return null;
  };
  paymentNeedsUpdate = (
    existingPayment,
    pendingBeforePayment,
    paymentAmount,
    paymentDate,
    balanceAfter,
    vendor,
    invoice
  ) => {
    console.log("vendor_id",
      Number(existingPayment.vendor_id),
      Number(vendor.id));
    console.log("invoice_id",
      Number(existingPayment.invoice_id),
      Number(invoice.id));
    console.log("pending_amount",
      Number(existingPayment.pending_amount),
      Number(pendingBeforePayment));
    console.log("payment_amount",
      Number(existingPayment.payment_amount),
      Number(paymentAmount));
    console.log("payment_date",
      this.parseAndFormatDate(existingPayment.payment_date),
      this.parseAndFormatDate(paymentDate));
    console.log("balance_after",
      Number(existingPayment.balance_after),
      Number(balanceAfter));
    console.log("payment_mode",
      existingPayment.payment_mode);
    console.log("transaction_ref",
      existingPayment.transaction_ref);
    console.log("notes",
      existingPayment.notes);
    return (
      Number(existingPayment.vendor_id) !== Number(vendor.id) ||
      Number(existingPayment.invoice_id) !== Number(invoice.id) ||
      Number(existingPayment.pending_amount) !== Number(pendingBeforePayment) ||
      Number(existingPayment.payment_amount) !== Number(paymentAmount) ||
      this.parseAndFormatDate(existingPayment.payment_date) !==
      this.parseAndFormatDate(paymentDate) ||
      Number(existingPayment.balance_after) !== Number(balanceAfter)
    );
  };

  // Comprehensive pre-validation of all sheet rows (Pass 1)
  validateAllImportRows = (rows) => {
    const errors = [];
    const validRows = [];

    if (!rows || rows.length === 0) {
      return { errors: ["The uploaded file contains no data."], validRows: [] };
    }

    // Header validation on first non-empty row
    const firstNonEmpty = rows.find((r) => !this.isEmptyRow(r));
    if (!firstNonEmpty) {
      return { errors: ["The uploaded file contains no valid data rows."], validRows: [] };
    }

    const hasClientCol = this.getCellValue(firstNonEmpty, ["Client", "Client Name", "Vendor", "Vendor Name"]) !== undefined;
    const hasDateCol = this.getCellValue(firstNonEmpty, ["Date", "Invoice Date"]) !== undefined;
    const hasAmountCol = this.getCellValue(firstNonEmpty, ["Amount", "Invoice Amount"]) !== undefined;

    const missingHeaders = [];
    if (!hasClientCol) missingHeaders.push("Client (e.g. Client, Client Name, Vendor, Vendor Name)");
    if (!hasDateCol) missingHeaders.push("Date (e.g. Date, Invoice Date)");
    if (!hasAmountCol) missingHeaders.push("Amount (e.g. Amount, Invoice Amount)");

    if (missingHeaders.length > 0) {
      errors.push(`Header error: Missing required column(s): ${missingHeaders.join(", ")}`);
      return { errors, validRows: [] };
    }

    for (let i = 0; i < rows.length; i++) {
      const rawRow = rows[i];
      this.setState({
        importProgress: Math.round(((i + 1) / rows.length) * 100)
      });
      const rowNumber = rawRow.__excelRowNumber || i + 2;
      const sheetName = rawRow.__sheetName || "Unknown Sheet";
      const tableNumber = rawRow.__tableNumber || "Unknown Table";
      // Ignore empty rows
      if (this.isEmptyRow(rawRow)) {
        console.log(
          "Skipping row",
          rowNumber,
          rawRow
        );
        continue;
      }

      const clientVal = this.getCellValue(rawRow, ["Client", "Client Name", "Vendor", "Vendor Name"]);
      const client = clientVal ? String(clientVal).trim() : "";
      const dateVal = this.getCellValue(rawRow, ["Date", "Invoice Date", "InvoiceDate", "Invoice_Date"]);
      const amountVal = this.getCellValue(rawRow, ["Amount", "Invoice Amount"]);
      const paidAmountVal = this.getCellValue(rawRow, ["PaidAmount", "Paid Amount", "Payment Amount", "Paid"]);
      const paymentDateVal = this.getCellValue(rawRow, ["PaymentDate", "Payment Date", "payment_date"]);

      // 1. Client availability check
      if (!client) {
        errors.push(`Sheet "${sheetName}" - Table ${tableNumber} - Row ${rowNumber}: Client/Vendor name is missing.`);
      }

      // 2. Invoice Date format & validity check
      const formattedDate = this.parseAndFormatDate(dateVal);
      if (!formattedDate) {
        errors.push(`Sheet "${sheetName}" - Table ${tableNumber} - Row ${rowNumber}: Date contains an invalid date (${dateVal || "blank"}).`);
      }

      // 3. Amount check
      const amount = Number(amountVal);
      if (
        amountVal === undefined ||
        amountVal === null ||
        String(amountVal).trim() === ""
      ) {
        console.log(
          `Skipping row ${rowNumber} because Amount is blank.`
        );
        continue;
      } else if (amount < 0) {
        errors.push(`Sheet "${sheetName}" - Table ${tableNumber} - Row ${rowNumber}: "Amount" cannot be negative (${amountVal}).`);
      }

      // 4. Determine if Paid Amount / Payment Date are provided
      const isPaidAmountProvided =
        paidAmountVal !== undefined &&
        paidAmountVal !== null &&
        String(paidAmountVal).trim() !== "";

      const isPaymentDateProvided =
        paymentDateVal !== undefined &&
        paymentDateVal !== null &&
        String(paymentDateVal).trim() !== "";

      let hasPayment = false;
      let paidAmount = 0;
      let formattedPaymentDate = null;

      if (isPaidAmountProvided || isPaymentDateProvided) {

        // Payment information is incomplete
        if (
          isPaidAmountProvided !==
          isPaymentDateProvided
        ) {
          console.log(
            `Row ${rowNumber}: Incomplete payment information. Invoice will be imported without payment.`
          );
          hasPayment = false;
          paidAmount = 0;
          formattedPaymentDate = null;
          validRows.push({
            rowNumber,
            client,
            date: formattedDate,
            amount,
            paidAmount: 0,
            pendingAmount: amount,
            hasPayment: false,
            paymentDate: null,
            status: "NOTPAID",
            rawRow,
          });
          continue;
        }

        if (
          isPaidAmountProvided &&
          isPaymentDateProvided
        ) {
          paidAmount = Number(paidAmountVal);

          if (Number.isNaN(paidAmount)) {
            errors.push(
              `Row ${rowNumber}: "PaidAmount" must be a valid number (${paidAmountVal}).`
            );
          } else if (paidAmount < 0) {
            errors.push(
              `Row ${rowNumber}: "PaidAmount" cannot be negative (${paidAmountVal}).`
            );
          } else if (paidAmount > 0) {

            hasPayment = true;

            formattedPaymentDate =
              this.parseAndFormatDate(
                paymentDateVal
              );

            if (!formattedPaymentDate) {
              errors.push(
                `Row ${rowNumber}: PaymentDate contains an invalid date (${paymentDateVal}).`
              );
            }

            if (
              !Number.isNaN(amount) &&
              paidAmount > amount
            ) {
              errors.push(
                `Row ${rowNumber}: PaidAmount (${paidAmount}) cannot exceed Invoice Amount (${amount}).`
              );
            }
          }
        }
      }

      const pendingAmount = amount - paidAmount;
      validRows.push({
        rowNumber,
        client,
        date: formattedDate,
        amount,
        paidAmount,
        pendingAmount,
        hasPayment,
        paymentDate: formattedPaymentDate,
        status: rawRow["Status"] || (hasPayment ? (paidAmount >= amount ? "PAID" : "PARTIAL") : "NOTPAID"),
        rawRow,
      });
    }
    return { errors, validRows };
  };

  calculateInvoiceStatus = (
    invoiceAmount,
    totalPaid
  ) => {
    const amount = Number(invoiceAmount);
    const paid = Number(totalPaid);
    if (paid === 0) {
      return "NOTPAID";
    }
    if (paid < amount) {
      return "PARTIAL";
    }
    if (paid === amount) {
      return "PAID";
    }
    return "OVERPAID";
  };

  calculatePaymentBalance = (invoiceId, paymentAmount, excludePaymentId = null) => {
    const invoice = (this.state.invoices || []).find(
      (inv) => Number(inv.id) === Number(invoiceId)
    );
    if (!invoice) {
      return 0;
    }
    const alreadyPaid = (this.state.payments || [])
      .filter(
        (p) =>
          Number(p.invoice_id) === Number(invoiceId) &&
          Number(p.id) !== Number(excludePaymentId)
      )
      .reduce(
        (sum, p) => sum + Number(p.payment_amount || 0),
        0
      );
    return (
      Number(invoice.invoice_amount) -
      alreadyPaid -
      Number(paymentAmount || 0)
    );
  };

  isDatePeriod = (value) => {
    if (value === undefined || value === null) {
      return false;
    }
    const str = String(value).trim();
    return /^\d{1,2}\s*to\s*\d{1,2}$/i.test(str);
  };

  resolveInvoicePeriodDate = (periodValue, previousDate) => {
    if (!this.isDatePeriod(periodValue)) {
      return null;
    }
    if (!previousDate) {
      return null;
    }
    const match = String(periodValue)
      .trim()
      .match(/^(\d{1,2})\s*to\s*(\d{1,2})$/i);
    if (!match) {
      return null;
    }
    // We only need the LAST date from the range.
    const lastDay = Number(match[2]);
    // Convert previous row's date to YYYY-MM-DD.
    const formattedPreviousDate =
      this.parseAndFormatDate(previousDate);
    if (!formattedPreviousDate) {
      return null;
    }
    const previousParts =
      formattedPreviousDate.split("-");
    const year = Number(previousParts[0]);
    const month = Number(previousParts[1]);
    if (
      !year ||
      !month ||
      !lastDay ||
      lastDay < 1 ||
      lastDay > 31
    ) {
      return null;
    }
    return `${year}-${String(month).padStart(2, "0")}-${String(
      lastDay
    ).padStart(2, "0")}`;
  };
  resolveInvoiceDatesFromPreviousRows = (rows) => {
    let previousValidDate = null;
    return (rows || []).map((row) => {
      const dateValue = this.getCellValue(row, [
        "Date",
        "Invoice Date",
        "InvoiceDate",
        "Invoice_Date",
      ]);
      if (
        dateValue === undefined ||
        dateValue === null ||
        String(dateValue).trim() === ""
      ) {
        if (previousValidDate) {
          return {
            ...row,
            Date: previousValidDate,
          };
        }
        return row;
      }
      const dateString = String(dateValue).trim();
      // ============================================================
      // DATE PERIOD: 01to30, 01to15, 16to30, etc.
      // ============================================================
      if (this.isDatePeriod(dateString)) {
        const resolvedDate =
          this.resolveInvoicePeriodDate(
            dateString,
            previousValidDate
          );
        if (resolvedDate) {
          return {
            ...row,
            Date: resolvedDate,
          };
        }
        return row;
      }
      // ============================================================
      // NORMAL DATE
      // ============================================================
      const formattedDate =
        this.parseAndFormatDate(dateValue);
      if (formattedDate) {
        previousValidDate = formattedDate;
        return {
          ...row,
          Date: formattedDate,
        };
      }
      return row;
    });
  };

  resolveClientFromPreviousRows = (rows) => {
    let previousClient = "";
    return (rows || []).map((row) => {
      const clientValue = this.getCellValue(row, [
        "Client",
        "Client Name",
        "Vendor",
        "Vendor Name",
      ]);
      // ============================================================
      // BLANK CLIENT
      // Use previous Client from THIS SHEET
      // ============================================================
      if (
        clientValue === undefined ||
        clientValue === null ||
        String(clientValue).trim() === ""
      ) {
        if (previousClient) {
          return {
            ...row,
            Client: previousClient,
          };
        }
        return row;
      }
      // ============================================================
      // NEW CLIENT
      // Remember it
      // ============================================================
      const currentClient =
        String(clientValue).trim();
      previousClient = currentClient;
      return {
        ...row,
        Client: currentClient,
      };
    });
  };

  saveImportedPayments = async (rows) => {
    this.setState({
      importProgress: Math.round(
        ((rows + 1) / rows.length) * 100
      )
    });
    try {
      // ============================================================
      // 2. NORMALIZE EXCEL ROWS
      // ============================================================
      // Fill blank client names using previous client
      let normalizedRows = this.resolveClientFromPreviousRows(rows);
      // Resolve dates like 01to30 using previous valid date
      normalizedRows = this.resolveInvoiceDatesFromPreviousRows(normalizedRows);
      // Normalize payment dates
      normalizedRows = normalizedRows.map((row) => {
        const paymentDateValue = this.getCellValue(row, [
          "PaymentDate",
          "Payment Date",
          "payment_date",
          "Paid Date",
          "PaidDate",
        ]);
        return {
          ...row,
          PaymentDate:
            this.parseAndFormatDate(paymentDateValue) ||
            paymentDateValue,
        };
      });
      console.log("IMPORT ROWS AFTER NORMALIZATION:", normalizedRows);
      // ============================================================
      // 3. VALIDATE EXCEL
      // ============================================================
      const { errors, validRows } = this.validateAllImportRows(normalizedRows);
      if (errors.length > 0) {
        alert(`Import blocked!\n\n${errors.join("\n")}`);
        return;
      }
      if (!validRows.length) {
        alert("No valid rows found.");
        return;
      }

      // ============================================================
      // 4. COUNTERS
      // ============================================================

      let vendorsCreatedCount = 0;
      let invoicesCreatedCount = 0;
      let invoicesUpdatedCount = 0;
      let paymentsCreatedCount = 0;
      let paymentsUpdatedCount = 0;

      const importErrors = [];
      const host = clientHost;
      const apiKey = storeFresh.key;
      const storeId = storeFresh.storeId;

      // ============================================================
      // 5. FETCH FRESH DATA
      // ============================================================

      const fetchPaymentsAsync = () => {
        return new Promise((resolve, reject) => {
          const apiPath = new Uri(
            host + GET_PAYMENTS
          ).addQueryParam(
            "store_id",
            storeId
          );

          getResponseClient(
            apiPath,
            apiKey,
            (response) => {
              const list =
                Array.isArray(response?.result)
                  ? response.result
                  : Array.isArray(response?.data)
                    ? response.data
                    : Array.isArray(response)
                      ? response
                      : [];

              resolve(list);
            },
            reject
          );
        });
      };

      let latestVendors = await this.fetchVendorsAsync();
      let latestInvoices = await this.fetchInvoicesAsync();
      let latestPayments = await fetchPaymentsAsync();
      // ============================================================
      // FAST LOOKUP MAPS
      // ============================================================
      const vendorMap = new Map();
      latestVendors.forEach((v) => {
        vendorMap.set(
          this.normalizeVendorName(v.vendor_name),
          v
        );
      });
      const invoiceMap = new Map();
      latestInvoices.forEach((inv) => {
        const key =
          `${inv.vendor_id}|` +
          `${this.parseAndFormatDate(inv.invoice_date)}|` +
          `${Number(inv.invoice_amount || 0)}`;
        invoiceMap.set(key, inv);
      });
      const paymentMap = new Map();
      latestPayments.forEach((payment) => {
        const invoice = latestInvoices.find(
          (inv) => Number(inv.id) === Number(payment.invoice_id)
        );
        if (!invoice) return;
        const key =
          `${invoice.vendor_id}|` +
          `${this.parseAndFormatDate(invoice.invoice_date)}|` +
          `${Number(invoice.invoice_amount || 0)}|` +
          `${this.parseAndFormatDate(payment.payment_date)}|` +
          `${Number(payment.payment_amount || 0)}`;
        paymentMap.set(key, payment);
      });
      console.log("FRESH VENDORS:", latestVendors);
      console.log("FRESH INVOICES:", latestInvoices);
      console.log("FRESH PAYMENTS:", latestPayments);

      // ============================================================
      // 6. PROCESS EACH EXCEL ROW
      // ============================================================
      for (let index = 0; index < validRows.length; index++) {
        const item = validRows[index];
        this.setState({
          importProgress: Math.round(
            ((index + 1) / validRows.length) * 100
          )
        });
        const rowNumber = item.rowNumber;
        try {
          const clientName = String(item.client || "").trim();
          const invoiceDate = String(item.date || "").trim();
          const invoiceAmount = Number(item.amount || 0);

          const paymentAmount = Number(item.paidAmount || 0);
          const paymentDate = this.parseAndFormatDate(
            item.paymentDate
          );
          console.log("========== FINAL IMPORT DATA ==========");
          console.log({
            rowNumber,
            clientName,
            invoiceDate,
            invoiceAmount,
            paymentAmount,
            paymentDate,
            hasPayment: item.hasPayment
          });
          console.log(`\n========== IMPORT ROW ${rowNumber} ==========`);

          console.log({
            clientName,
            invoiceDate,
            invoiceAmount,
            paymentAmount,
            paymentDate,
          });

          // ========================================================
          // A. FIND VENDOR
          // ========================================================

          const normalizedClient =
            this.normalizeVendorName(clientName);

          let vendor = vendorMap.get(normalizedClient);

          if (!vendor) {
            console.log(
              `ROW ${rowNumber}: Vendor not found. Creating vendor.`
            );

            vendor = await this.createVendor(clientName);

            if (!vendor?.id) {
              throw new Error(
                `Vendor "${clientName}" could not be created.`
              );
            }
            vendorsCreatedCount++;
            latestVendors.push(vendor);
            vendorMap.set(normalizedClient, vendor);
          }

          console.log("MATCHED VENDOR:", vendor);

          // ========================================================
          // B. FIND INVOICE
          //
          // IMPORTANT:
          // Invoice identity is:
          //
          // Client/Vendor
          // + Invoice Date
          // + Invoice Amount
          //
          // ========================================================
          const invoiceKey =
            `${vendor.id}|${invoiceDate}|${invoiceAmount}`;
          let invoice = invoiceMap.get(invoiceKey);
          // ========================================================
          // C. IF INVOICE NOT FOUND, CREATE IT
          // ========================================================

          if (!invoice) {
            console.log(
              `ROW ${rowNumber}: Invoice not found. Creating invoice.`
            );

            invoice = await this.createInvoice(
              vendor.id,
              {
                date: invoiceDate,
                amount: invoiceAmount,
                paidAmount: 0,
              }
            );

            if (!invoice?.id) {
              throw new Error(
                `Invoice could not be created.`
              );
            }
            invoicesCreatedCount++;
            latestInvoices.push(invoice);
            invoiceMap.set(invoiceKey, invoice);

            console.log(
              "NEW INVOICE:",
              invoice
            );
          }

          // ========================================================
          // D. IMPORTANT:
          // FIND PAYMENT ONLY AFTER INVOICE IS IDENTIFIED
          //
          // Payment matching:
          //
          // Invoice ID
          // +
          // Payment Date
          //
          // Payment ID from Excel is NOT USED.
          // ========================================================

          if (
            !paymentDate ||
            !Number.isFinite(paymentAmount) ||
            paymentAmount <= 0
          ) {
            console.log(
              `ROW ${rowNumber}: No payment information.`
            );
            continue;
          }

          console.log(
            "SEARCHING PAYMENT:",
            {
              invoiceId: invoice.id,
              paymentDate,
              paymentAmount,
            }
          );

          // ========================================================
          // E. FIND EXISTING PAYMENT
          // ========================================================
          const paymentKey = `${vendor.id}|${invoiceDate}|${invoiceAmount}|${paymentDate}|${paymentAmount}`;
          const existingPayment = paymentMap.get(paymentKey);
          console.log("EXISTING PAYMENT:", existingPayment);

          // ========================================================
          // F. CALCULATE TOTAL ALREADY PAID
          // ========================================================

          const otherPaymentsPaid =
            latestPayments
              .filter(
                (p) =>
                  Number(p.invoice_id) ===
                  Number(invoice.id) &&
                  (
                    !existingPayment ||
                    Number(p.id) !==
                    Number(existingPayment.id)
                  )
              )
              .reduce(
                (sum, p) =>
                  sum +
                  Number(p.payment_amount || 0),
                0
              );

          const pendingBeforePayment =
            invoiceAmount -
            otherPaymentsPaid;

          const balanceAfter =
            pendingBeforePayment -
            paymentAmount;

          console.log(
            "PAYMENT CALCULATION:",
            {
              invoiceAmount,
              otherPaymentsPaid,
              pendingBeforePayment,
              paymentAmount,
              balanceAfter,
            }
          );

          // ========================================================
          // G. PREVENT OVERPAYMENT
          // ========================================================

          if (
            paymentAmount >
            pendingBeforePayment
          ) {
            throw new Error(
              `Payment amount ${paymentAmount} exceeds pending amount ${pendingBeforePayment}.`
            );
          }

          // ========================================================
          // H. UPDATE EXISTING PAYMENT
          // ========================================================

          if (existingPayment) {
            console.log("===== PAYMENT CHECK =====");
            console.log("Existing:", {
              vendor_id: existingPayment.vendor_id,
              invoice_id: existingPayment.invoice_id,
              pending_amount: existingPayment.pending_amount,
              payment_amount: existingPayment.payment_amount,
              payment_date: existingPayment.payment_date,
              balance_after: existingPayment.balance_after,
            });

            console.log("Excel:", {
              vendor_id: vendor.id,
              invoice_id: invoice.id,
              pending_amount: pendingBeforePayment,
              payment_amount: paymentAmount,
              payment_date: paymentDate,
              balance_after: balanceAfter,
            });

            console.log(
              "Needs Update:",
              this.paymentNeedsUpdate(
                existingPayment,
                pendingBeforePayment,
                paymentAmount,
                paymentDate,
                balanceAfter,
                vendor,
                invoice
              )
            );

            if (
              !this.paymentNeedsUpdate(
                existingPayment,
                pendingBeforePayment,
                paymentAmount,
                paymentDate,
                balanceAfter,
                vendor,
                invoice
              )
            ) {
              console.log(`ROW ${rowNumber}: Payment unchanged. Skipping update.`);
              continue;
            }
            console.log(
              `ROW ${rowNumber}: UPDATING PAYMENT ${existingPayment.id}`
            );

            const formData = new FormData();

            formData.append(
              "id",
              String(existingPayment.id)
            );

            formData.append(
              "vendor_id",
              String(vendor.id)
            );

            formData.append(
              "invoice_id",
              String(invoice.id)
            );

            formData.append(
              "pending_amount",
              String(pendingBeforePayment)
            );

            formData.append(
              "payment_amount",
              String(paymentAmount)
            );

            formData.append(
              "payment_date",
              paymentDate
            );

            formData.append(
              "balance_after",
              String(balanceAfter)
            );

            formData.append(
              "payment_mode",
              existingPayment.payment_mode || ""
            );

            formData.append(
              "transaction_ref",
              existingPayment.transaction_ref || ""
            );

            formData.append(
              "notes",
              existingPayment.notes || ""
            );

            formData.append(
              "store_id",
              String(storeId)
            );

            await new Promise(
              (resolve, reject) => {
                postClientDataResponse(
                  host + UPDATE_PAYMENT,
                  apiKey,
                  formData,

                  (response) => {
                    console.log(
                      "UPDATE PAYMENT SUCCESS:",
                      response
                    );

                    const index =
                      latestPayments.findIndex(
                        (p) =>
                          Number(p.id) ===
                          Number(
                            existingPayment.id
                          )
                      );

                    if (index !== -1) {
                      latestPayments[index] = {
                        ...latestPayments[index],
                        vendor_id: vendor.id,
                        invoice_id: invoice.id,
                        pending_amount:
                          pendingBeforePayment,
                        payment_amount:
                          paymentAmount,
                        payment_date:
                          paymentDate,
                        balance_after:
                          balanceAfter,
                      };
                    }
                    // UPDATE THE MAP
                    paymentMap.set(
                      paymentKey,
                      latestPayments[index]
                    );
                    paymentsUpdatedCount++;

                    resolve(response);
                  },

                  (error) => {
                    console.error(
                      "UPDATE PAYMENT ERROR:",
                      error
                    );

                    reject(
                      error ||
                      new Error(
                        "Payment update failed."
                      )
                    );
                  }
                );
              }
            );

            continue;
          }

          // ========================================================
          // I. CREATE NEW PAYMENT
          // ========================================================

          console.log(
            `ROW ${rowNumber}: CREATING NEW PAYMENT`
          );

          const formData = new FormData();

          formData.append(
            "vendor_id",
            String(vendor.id)
          );

          formData.append(
            "invoice_id",
            String(invoice.id)
          );

          formData.append(
            "pending_amount",
            String(pendingBeforePayment)
          );

          formData.append(
            "payment_amount",
            String(paymentAmount)
          );

          formData.append(
            "payment_date",
            paymentDate
          );

          formData.append(
            "balance_after",
            String(balanceAfter)
          );

          formData.append(
            "payment_mode",
            ""
          );

          formData.append(
            "transaction_ref",
            ""
          );

          formData.append(
            "notes",
            ""
          );

          formData.append(
            "store_id",
            String(storeId)
          );

          console.log(
            "FINAL ADD_PAYMENT DATA:",
            {
              vendor_id: vendor.id,
              invoice_id: invoice.id,
              pending_amount:
                pendingBeforePayment,
              payment_amount:
                paymentAmount,
              payment_date:
                paymentDate,
              balance_after:
                balanceAfter,
              store_id: storeId,
            }
          );

          await new Promise(
            (resolve, reject) => {
              postClientDataResponse(
                host + ADD_PAYMENT,
                apiKey,
                formData,

                (response) => {
                  console.log("=================================");
                  console.log("SENDING PAYMENT TO BACKEND");
                  console.log({
                    url: host + ADD_PAYMENT,
                    vendor_id: vendor.id,
                    invoice_id: invoice.id,
                    pending_amount: pendingBeforePayment,
                    payment_amount: paymentAmount,
                    payment_date: paymentDate,
                    balance_after: balanceAfter,
                    store_id: storeId
                  });
                  console.log("=================================");
                  console.log("ADD PAYMENT SUCCESS:", response);

                  const responseData =
                    response?.data?.result ||
                    response?.result ||
                    response?.data?.data ||
                    response?.data;

                  let createdPayment;

                  if (
                    responseData &&
                    typeof responseData ===
                    "object"
                  ) {
                    createdPayment = {
                      ...responseData,

                      vendor_id:
                        responseData.vendor_id ??
                        vendor.id,

                      invoice_id:
                        responseData.invoice_id ??
                        invoice.id,

                      payment_date:
                        responseData.payment_date ??
                        paymentDate,

                      payment_amount:
                        Number(
                          responseData.payment_amount ??
                          paymentAmount
                        ),

                      pending_amount:
                        Number(
                          responseData.pending_amount ??
                          pendingBeforePayment
                        ),

                      balance_after:
                        Number(
                          responseData.balance_after ??
                          balanceAfter
                        ),
                    };
                  } else {
                    createdPayment = {
                      id: responseData,
                      vendor_id: vendor.id,
                      invoice_id: invoice.id,
                      payment_date: paymentDate,
                      payment_amount:
                        paymentAmount,
                      pending_amount:
                        pendingBeforePayment,
                      balance_after:
                        balanceAfter,
                    };
                  }

                  // VERY IMPORTANT:
                  // Add newly created payment to cache.
                  // This prevents duplicate payment creation
                  // when the Excel has multiple rows.
                  latestPayments.push(createdPayment);
                  paymentMap.set(paymentKey, createdPayment);
                  paymentsCreatedCount++;

                  console.log(
                    "PAYMENT ADDED TO CACHE:",
                    createdPayment
                  );

                  resolve(response);
                },

                (error) => {
                  console.error(
                    "ADD PAYMENT ERROR:",
                    error
                  );

                  reject(
                    error ||
                    new Error(
                      "Payment creation failed."
                    )
                  );
                }
              );
            }
          );
        } catch (error) {
          console.error(
            `ROW ${rowNumber} IMPORT ERROR:`,
            error
          );

          importErrors.push(
            `Row ${rowNumber} (${item.client}): ${error?.message ||
            "Payment import failed."
            }`
          );
        }
      }

      // ============================================================
      // 7. REFRESH EVERYTHING FROM DATABASE
      // ============================================================

      await this.fetchVendorsAsync().catch(() => { });
      await this.fetchInvoicesAsync().catch(() => { });
      this.getPayments();

      // ============================================================
      // 8. RESULT
      // ============================================================

      if (importErrors.length > 0) {
        alert(
          `IMPORT COMPLETED WITH ERRORS\n\n` +
          `Total Rows: ${validRows.length}\n` +
          `Vendors Created: ${vendorsCreatedCount}\n` +
          `Invoices Created: ${invoicesCreatedCount}\n` +
          `Invoices Updated: ${invoicesUpdatedCount}\n` +
          `Payments Created: ${paymentsCreatedCount}\n` +
          `Payments Updated: ${paymentsUpdatedCount}\n` +
          `Failed Rows: ${importErrors.length}\n\n` +
          `ERRORS:\n${importErrors.join("\n")}`
        );
      } else {
        alert(
          `IMPORT COMPLETED SUCCESSFULLY\n\n` +
          `Total Rows: ${validRows.length}\n` +
          `Vendors Created: ${vendorsCreatedCount}\n` +
          `Invoices Created: ${invoicesCreatedCount}\n` +
          `Invoices Updated: ${invoicesUpdatedCount}\n` +
          `Payments Created: ${paymentsCreatedCount}\n` +
          `Payments Updated: ${paymentsUpdatedCount}`
        );
      }
    }
    catch (error) {
      console.error(error);
      alert(error.message);
    }
    finally {
      this.setState({
        importing: false,
        importProgress: 0
      });
    }
  }

  convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };
  UploadFilebyId = (id, file, type) => {
    let img = file
    const handleFileRead = async (event) => {
      const file = img;
      const base64 = await this.convertBase64(file);
      const requestBody = {
        id: id,
        image: base64,
      };
      postClientDataResponse(
        clientHost + UPDATE_PAYMENT_BILL_IMAGE,
        storeFresh.key,
        requestBody,
        (onSuccessResponse) => {
          this.setState({
            invoiceFile: "",
            editedinvoiceFile: ""
          })
          this.getPayments();
        },
        (onError) => {
          console.log(onError.message);
        }
      );
    };
    if (img === '' || img === null || img === undefined) {
      console.log("No files Selected")
    }
    else {
      handleFileRead();
    }
  }
  sortVendors = (vendors = []) => {
    return [...vendors].sort((a, b) => {
      const nameA = (a.vendor_name || "").trim();
      const nameB = (b.vendor_name || "").trim();
      const getType = (name) => {
        if (/^[A-Za-z]/.test(name)) return 1;   // Alphabets
        if (/^[0-9]/.test(name)) return 2;      // Numbers
        return 3;                               // Special characters
      };
      const typeA = getType(nameA);
      const typeB = getType(nameB);
      // First: Alphabet → Number → Special
      if (typeA !== typeB) {
        return typeA - typeB;
      }
      // Within the same type: alphabetical/natural order
      return nameA.localeCompare(nameB, undefined, {
        numeric: true,
        sensitivity: "base",
      });
    });
  };
  render() {
    return (
      <VendorPaymentComponent
        payments={this.state.payments}
        vendors={this.state.vendors}
        invoices={this.state.invoices}
        refreshInvoices={this.refreshInvoices}
        // Form
        selectedVendor={this.state.selectedVendor}
        selectedInvoice={this.state.selectedInvoice}
        paymentAmount={this.state.paymentAmount}
        pendingAmount={this.state.pendingAmount}
        balance_after={this.state.balance_after}
        paymentDate={this.state.paymentDate}
        paymentMode={this.state.paymentMode}
        transactionRef={this.state.transactionRef}
        notes={this.state.notes}
        onVendorChange={this.onVendorChange}
        onInvoiceChange={this.onInvoiceChange}
        onPaymentAmountChange={this.onPaymentAmountChange}
        onPaymentDateChange={this.onPaymentDateChange}
        onPaymentModeChange={this.onPaymentModeChange}
        onTransactionRefChange={this.onTransactionRefChange}
        onNotesChange={this.onNotesChange}
        onPaymentFileChange={this.onPaymentFileChange}
        addPayment={this.addPayment}
        updatePayment={this.updatePayment}
        deletePayment={this.deletePayment}
        // Filters
        filterVendorId={this.state.filterVendorId}
        filterFromDate={this.state.filterFromDate}
        filterToDate={this.state.filterToDate}
        filterStatus={this.state.filterStatus}
        onFilterStatusChange={this.onFilterStatusChange}
        onFilterVendorChange={this.onFilterVendorChange}
        onFilterFromDateChange={this.onFilterFromDateChange}
        onFilterToDateChange={this.onFilterToDateChange}
        onResetFilters={this.onResetFilters}
        // Export
        onExport={this.onExport}
        onImportFileChange={this.onImportFileChange}
        importExcel={this.importExcel}

        importing={this.state.importing}
        importProgress={this.state.importProgress}
      />
    );
  }
}
export default VendorPaymentContainer;